module.exports = __webpack_public_path__ + "img/art-ryan.57f50bdb.jpg";